export const OPERATOR_ROUTE_PREFIXES = [
  '/dashboard',
  '/users',
  '/transactions',
  '/settlements',
  '/reconciliation',
  '/settings',
  '/embed-test',
];

const resolveLegacyOperatorRoute = (pathname: string, search: string): string | null => {
  if (pathname !== '/admin/onramper-flow-approvals') {
    return null;
  }

  const params = new URLSearchParams(search);
  params.set('tab', 'onramper-flow');

  return `/settings?${params.toString()}`;
};

export const isAllowedOperatorRoute = (pathname: string): boolean => {
  if (!pathname.startsWith('/') || pathname.startsWith('//')) {
    return false;
  }

  return OPERATOR_ROUTE_PREFIXES.some((prefix) =>
    pathname === prefix || pathname.startsWith(`${prefix}/`));
};

export const resolveSafeOperatorRoute = (route: string | null | undefined): string | null => {
  if (!route) {
    return null;
  }

  try {
    const parsed = new URL(route, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return null;
    }

    const legacyRoute = resolveLegacyOperatorRoute(parsed.pathname, parsed.search);
    if (legacyRoute) {
      return legacyRoute;
    }

    if (!isAllowedOperatorRoute(parsed.pathname)) {
      return null;
    }

    return `${parsed.pathname}${parsed.search}`;
  } catch {
    return null;
  }
};
